import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ModelBase, 
  PlayerObject
} from "@models";
import { 
  CharacterItem, 
  CharacterSpell, 
  PseudoItem, 
  SummonOption2 
} from "@dndModels";

import DandDCharacterUtilities from '@dndUtilities/char_utilities';
import DandDAPI from '@dndUtilities/system_api';
import CommonUtilities from '@utilities/common_utilities';

interface Props {
  obj: ModelBase | PlayerObject | CharacterSpell | CharacterItem | PseudoItem | SummonOption2;
  display_variant?: boolean;
  display_sb?: boolean;
}

const char_util = DandDCharacterUtilities.getInstance();
const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export default function DisplayObject({
  obj,
  display_variant = false,
  display_sb = false
}: Props) {

  // const data_type = obj instanceof PseudoItem ? "item" : (obj instanceof SummonOption2 ? "summon" : obj.data_type);
  const detail_format = obj instanceof ModelBase || obj instanceof PlayerObject ? obj.detailFormat() : "";
  
  const detail = char_util.getStringWithReplacementsWithObject({ clean_me: detail_format, backup: "", obj });
  const sbs = display_sb && obj instanceof ModelBase ? api.source_books.filter(o => obj.source_book_ids.includes(o._id)) : [];

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        { display_variant && obj instanceof ModelBase ? obj.true_name : (obj instanceof PlayerObject || obj instanceof CharacterItem || obj instanceof CharacterSpell ? obj.use_name : obj.name) }
      </Grid>
      <Grid
        className="small_label gray"
        size={{
          xs: 12
        }}>
        { detail }
      </Grid>
      { display_sb && 
        <Grid
          className="small_label gray"
          size={12}>
          { sbs.map(o => o.name).join(", ") }
        </Grid>
      }
    </Grid>
  );
}
